
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How much does piano storage in London cost?',
      answer:
        'Piano storage costs in London vary depending on the type of piano, the duration of storage, and the specific facility. Upright piano storage typically starts from around £30 to £60 per week for short-term arrangements, while monthly rates for long-term piano storage London can range from £80 to £150 per month. Grand piano storage is priced higher due to the additional space required, starting from approximately £100 to £200 per month. Prices vary between providers, so it is always worth obtaining multiple quotes and confirming that the facility offers climate-controlled conditions, adequate insurance coverage, and secure access before committing.',
    },
    {
      question: 'Is climate control important for piano storage?',
      answer:
        'Climate control is absolutely essential for safe piano storage. Pianos are highly sensitive to changes in temperature and humidity — fluctuations cause the wooden soundboard, bridges, and pin block to expand and contract, leading to cracked soundboards, loose tuning pins, and structural damage that can be extremely costly to repair. A quality piano storage London facility maintains a consistent temperature of 18–22°C and relative humidity between 45% and 65% year-round. Storing a piano in a standard self-storage unit without climate control, a garage, or a damp basement can cause irreversible damage within weeks, particularly during London\'s cold, damp winters.',
    },
    {
      question: 'How long can a piano be kept in storage?',
      answer:
        'A piano can be stored safely for any length of time — from a few weeks to several years — provided the storage conditions are correct. In a properly climate-controlled piano storage London facility with stable temperature and humidity, the instrument will remain in good condition indefinitely. However, it is recommended to have the piano tuned and inspected by a qualified technician when it comes out of storage, regardless of the duration. For very long-term storage exceeding 12 months, periodic inspections by a piano technician are advisable to check for any developing issues with the action, strings, or structural components.',
    },
    {
      question: 'Do piano storage companies in London collect and deliver?',
      answer:
        'Yes, most specialist piano storage London companies offer a complete collection and delivery service as part of their storage package. This means a trained team of piano movers will come to your property, carefully wrap and load your piano, transport it to the storage facility, and deliver it back to you when required. This integrated service is far safer than attempting to arrange separate removal and storage with different companies, as it ensures continuity of care and a single point of responsibility for your instrument throughout the entire storage period. Always confirm that collection and delivery are included in the quoted price or understand the additional costs involved.',
    },
    {
      question: 'What insurance is provided for pianos in storage?',
      answer:
        'Reputable piano storage London facilities provide comprehensive insurance coverage for instruments in their care, typically covering the full replacement value of the piano against risks including fire, flood, theft, and accidental damage. Coverage levels vary between providers — some offer standard coverage up to a set value while others provide bespoke policies for high-value instruments. Before placing your piano in storage, always confirm the exact level of insurance coverage provided, what risks are included and excluded, and whether the coverage is based on the piano\'s current market value or its original purchase price. For particularly valuable instruments, you may wish to arrange additional coverage through your own home or specialist musical instrument insurance policy.',
    },
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-4 text-[#0e0d0b]">
          Frequently Asked Questions — Piano Storage London
        </h2>
        <div className="w-24 h-1 bg-[#c9a84c] mx-auto mb-12" />
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-[#c9a84c]/20 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between bg-[#f5f5f0] hover:bg-[#c9a84c]/5 transition-colors cursor-pointer"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h4 className="text-lg font-semibold text-[#0e0d0b] pr-4">
                  {faq.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#c9a84c] transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  aria-hidden="true"
                />
              </button>
              {openIndex === index && (
                <div
                  id={`faq-answer-${index}`}
                  className="px-6 py-5 bg-white"
                >
                  <p className="text-[#1a1916] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
